//@ts-nocheck

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  if (!window.countdownsInit) {
    window.countdownsInit = true;

    const countdowns = document.querySelectorAll('.countdown-container');

    countdowns.forEach(function (container) {
      const targetDate = new Date(container.dataset.date);
      const daysEl = container.querySelector('.days');
      const hoursEl = container.querySelector('.hours');
      const minutesEl = container.querySelector('.minutes');
      const secondsEl = container.querySelector('.seconds');

      function updateCountdown() {
        const now = new Date();
        const distance = targetDate - now;

        if (distance <= 0) {
          const eventTimer = container.querySelector('.countdown-event-timer');
          if (eventTimer) {
            eventTimer.innerHTML = '<p>Event has started!</p>';
            if (interval) clearInterval(interval);
          }
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.textContent = days;
        hoursEl.textContent = hours;
        minutesEl.textContent = minutes;
        secondsEl.textContent = seconds;
      }
      const interval = setInterval(updateCountdown, 1000);
      updateCountdown();
    });
  }
});

// Typeform

const esimCompatibleDevices = {
  iPhone: {
    compatible: [
      'iPhone XS',
      'iPhone XS Max',
      'iPhone XR',
      'iPhone 11',
      'iPhone 11 Pro',
      'iPhone 11 Pro Max',
      'iPhone SE (2020)',
      'iPhone 12',
      'iPhone 12 mini',
      'iPhone 12 Pro',
      'iPhone 12 Pro Max',
      'iPhone 13',
      'iPhone 13 mini',
      'iPhone 13 Pro',
      'iPhone 13 Pro Max',
      'iPhone 14',
      'iPhone 14 Plus',
      'iPhone 14 Pro',
      'iPhone 14 Pro Max',
      'iPhone 15',
      'iPhone 15 Plus',
      'iPhone 15 Pro',
      'iPhone 15 Pro Max',
    ],
    minVersion: 12.1,
  },
  Samsung: {
    compatible: [
      'Galaxy S20',
      'Galaxy S21',
      'Galaxy S22',
      'Galaxy S23',
      'Galaxy Note 20',
      'Galaxy Z Fold',
      'Galaxy Z Flip',
      'Galaxy A54',
      'Galaxy A55',
    ],
    minVersion: null,
  },
  Google: {
    compatible: [
      'Pixel 3',
      'Pixel 3 XL',
      'Pixel 4',
      'Pixel 4 XL',
      'Pixel 5',
      'Pixel 6',
      'Pixel 7',
      'Pixel 8',
    ],
    minVersion: null,
  },
  OnePlus: {
    compatible: ['OnePlus 9', 'OnePlus 10', 'OnePlus 11'],
    minVersion: null,
  },
};

// Typeform configuration
const TYPEFORM_ID = '01JXY3GGMR0RMW60YHQ4Z9TM46';

function detectDevice() {
  const userAgent = navigator.userAgent;
  let deviceInfo = {
    brand: 'Unknown',
    model: 'Unknown',
    os: 'Unknown',
    version: 'Unknown',
    isCompatible: false,
    confidence: 'low',
  };

  // Detect iOS devices
  if (/iPhone/.test(userAgent)) {
    deviceInfo.brand = 'Apple';
    deviceInfo.os = 'iOS';

    // Extract iOS version
    const iosVersion = userAgent.match(/Version\/([\d.]+)/);
    if (iosVersion) {
      deviceInfo.version = `${iosVersion[1]}`;
    } else {
      const iosVersionChrome = userAgent.match(/OS (\d+)_(\d+)/);
      if (iosVersionChrome) {
        deviceInfo.version = `${iosVersionChrome[1]}.${iosVersionChrome[2]}`;
      }
    }

    // Detect iPhone model (simplified detection)
    if (/iPhone.*OS 1[2-9]|iPhone.*OS [2-9][0-9]/.test(userAgent)) {
      deviceInfo.model = 'iPhone';
      deviceInfo.isCompatible = true;
      deviceInfo.confidence = 'high';
    } else {
      deviceInfo.model = 'iPhone';
      deviceInfo.confidence = 'medium';
    }
  }

  // Detect Android devices
  else if (/Android/.test(userAgent)) {
    deviceInfo.os = 'Android';

    // Extract Android version
    const androidVersion = userAgent.match(/Android (\d+(?:\.\d+)?)/);
    if (androidVersion) {
      deviceInfo.version = androidVersion[1];
    }

    // Detect Samsung
    if (/Samsung|SM-/.test(userAgent)) {
      deviceInfo.brand = 'Samsung';
      deviceInfo.model = 'Samsung Galaxy';
      // Most newer Samsung devices support eSIM
      if (parseFloat(deviceInfo.version) >= 10) {
        deviceInfo.isCompatible = true;
        deviceInfo.confidence = 'medium';
      }
    }

    // Detect Google Pixel
    else if (/Pixel/.test(userAgent)) {
      deviceInfo.brand = 'Google';
      deviceInfo.model = 'Google Pixel';
      deviceInfo.isCompatible = true;
      deviceInfo.confidence = 'high';
    }

    // Detect OnePlus
    else if (/OnePlus/.test(userAgent)) {
      deviceInfo.brand = 'OnePlus';
      deviceInfo.model = 'OnePlus';
      deviceInfo.isCompatible = true;
      deviceInfo.confidence = 'medium';
    }
  }
  // console.log('device info ✅', deviceInfo);
  return deviceInfo;
}

function loadTypeformEmbed() {
  if (!document.getElementById('typeform-embed')) {
    const script = document.createElement('script');
    script.id = 'typeform-embed';
    script.src = 'https://embed.typeform.com/next/embed.js';
    script.defer = true;
    document.head.appendChild(script);
  }
}

function typeformObservers(typeformContainer, success) {
  const popupObserver = new MutationObserver((mutations) => {
    function closeTypeformPopup(popup) {
      const closeBtn = popup.querySelector('.tf-v1-close.tf-v1-close-icon');
      if (closeBtn) {
        console.log('close button,', closeBtn);
        closeBtn.click();
      } else {
        popup.remove();
      }
    }
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1 && node.classList.contains('tf-v1-popup')) {
          const popup = node;
          const handleClick = (e) => {
            const iframeWrapper = popup.querySelector('.tf-v1-iframe-wrapper');

            if (!iframeWrapper || !iframeWrapper.contains(e.target)) {
              closeTypeformPopup(popup);
            }
          };

          const handleKeydown = (e) => {
            if (e.key === 'Escape') closeTypeformPopup(popup);
          };

          const cleanupObserver = new MutationObserver(() => {
            if (!document.body.contains(popup)) {
              document.removeEventListener('click', handleClick, true);
              document.removeEventListener('keydown', handleKeydown, true);
              cleanupObserver.disconnect();
            }
          });

          document.addEventListener('click', handleClick, true);
          document.addEventListener('keydown', handleKeydown, true);
          cleanupObserver.observe(document.body, { childList: true, subtree: true });
        }
      }
    }
  });

  popupObserver.observe(document.body, { childList: true, subtree: true });

  const observer = new MutationObserver((mutations, obs) => {
    const button = typeformContainer.querySelector('button');
    if (button) {
      success === 'NA'
        ? (button.innerHTML = `Check if your device is compatible with eSIM <span><svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none">
<path d="M1.5 8H18M18 8L11 1M18 8L11 15" stroke="#0C1924" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg></span>`)
        : success
          ? (button.innerHTML = 'Check compatibility for a different device >')
          : (button.innerHTML = 'Check with a quick quiz >');
      button.style =
        'font-weight:400;font-size:14px;margin: 0 auto;text-decoration:underline;cursor:pointer;';
      obs.disconnect();
    }
  });

  observer.observe(typeformContainer, {
    childList: true,
    subtree: true,
  });
}

// Function to show Typeform popup
function showTypeformInline(container, success) {
  // Load Typeform embed script if not already loaded
  loadTypeformEmbed();

  const typeformContainer = document.createElement('span');
  typeformContainer.setAttribute('data-tf-live', TYPEFORM_ID);
  typeformContainer.setAttribute('data-tf-redirect-target', '_self');

  typeformContainer.classList.add('my-typeform');

  container.appendChild(typeformContainer);

  // document.body.style.overflow = 'hidden';

  typeformObservers(typeformContainer, success);
}

function resultContainerChanges(copy, className, success) {
  const description = document.querySelector('.checker-header');
  const checkAnotherDevice = document.getElementById('check-another-device');
  const eSimCheckerContainer = document.querySelector('.esim-checker');

  description.innerHTML = copy;
  eSimCheckerContainer.classList.remove('esim-checker-shimmer');
  eSimCheckerContainer.classList.add(className);
  checkAnotherDevice.classList.add('check_another_device');

  let container = '';
  success
    ? (container = document.getElementById('check-another-device'))
    : (container = document.querySelector('.checker-header .fail-message'));
  showTypeformInline(container, success);
}

function displayResult(deviceInfo) {
  const loadingSpinner = document.getElementById('loading-spinner');

  // Show popup for unknown or incompatible devices instead of redirecting
  if (!deviceInfo.isCompatible || deviceInfo.confidence === 'low') {
    let copy = `<div><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
<path d="M8.5 12.25H16.5M22.5 12.25C22.5 17.7728 18.0228 22.25 12.5 22.25C6.97715 22.25 2.5 17.7728 2.5 12.25C2.5 6.72715 6.97715 2.25 12.5 2.25C18.0228 2.25 22.5 6.72715 22.5 12.25Z" stroke="#0C1924" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg><span class="fail-message">We couldn’t confirm eSIM support for your device. </span> </div>`;
    resultContainerChanges(copy, 'esim-checker-fail', false);
    return;
  }

  let copy = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
<path d="M6.5 11L9.5 14L15.5 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#00964E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg><p>Your ${deviceInfo.model}${deviceInfo.version !== 'Unknown' ? ` (${deviceInfo.os} ${deviceInfo.version})` : ''}  is eSIM compatible!</p>`;
  resultContainerChanges(copy, 'esim-checker-success', true);

  loadingSpinner.style.display = 'none';

  let statusClass = '';
  let statusText = '';
  let actionButtons = '';
}

// Initialize the checker
setTimeout(() => {
  const deviceInfo = detectDevice();
  displayResult(deviceInfo);
}, 2000);

// Add event listeners for enhanced detection
window.addEventListener('load', () => {
  // Additional checks when page loads
  console.log('eSIM Compatibility Checker loaded');
});

document.querySelectorAll('.my-typeform').forEach((element) => {
  element.addEventListener('click', () => {
    const endpoint = 'https://portal.simify.com/api/v2/webhooks/customEvent';
    const payload = {
      eventSource: 'typeform',
      eventType: 'form_clicked',
      additionalInfo: 'Form ID: T5RFcT0C; Form Title: Compatibility Questions',
    };

    axios.post(endpoint, payload).catch((error) => {
      console.error('Error: ', error);
    });
  });
});

const desktopTypeformDivs = document.querySelectorAll('.esim-checker-desktop');

if (desktopTypeformDivs.length > 0 && window.innerWidth > 768) {
  desktopTypeformDivs.forEach((el) => {
    showTypeformInline(el, 'NA');
  });
}

// Disable Klaviyo on search
document.addEventListener('DOMContentLoaded', function () {
  const searchInputs = document.querySelectorAll('input[placeholder="Search country or region"]');
  if (searchInputs.length > 0) {
    searchInputs.forEach((searchInput) => {
      //  Disable Klaviyo form when search is focused

      searchInput.addEventListener('focus', function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['disableForms']);
      });

      // Re-enable Klaviyo form when search is blurred
      searchInput.addEventListener('blur', function () {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['enableForms']);
      });
    });
  }
});

//Ak custom code
$('.esim-work-wrapper .popup_link').on('click', function () {
  $('.compatible_works_video_popup .custom-model-main').addClass('model-open');
  $('.esim-compatible .custom-model-main').addClass('model-open');
});
//End Ak custom code

$('.esim-compatible-inner .popup_link').on('click', function () {
  $('#shopify-section-esim-compatible .custom-model-main').addClass('model-open');
  $('.esim-compatible .custom-model-main').addClass('model-open');
});
$('.popup_link').on('click', function () {
  $('#shopify-section-esim-compatible .custom-model-main').addClass('model-open');
  $('.esim-compatible .custom-model-main').addClass('model-open');
});
$('.close-btn, .bg-overlay').click(function () {
  $('#shopify-section-esim-compatible .custom-model-main').removeClass('model-open');
  $('.compatible_works_video_popup .custom-model-main').removeClass('model-open');
  $('.esim-compatible .custom-model-main').removeClass('model-open');
});
$('.popup_link_how').on('click', function () {
  $('.new-popup .custom-model-main').addClass('model-open');
  $('body').addClass('no-scroll');
});
$('.close-btn, .bg-overlay').click(function () {
  $('.new-popup .custom-model-main').removeClass('model-open');
  $('body').removeClass('no-scroll');
});

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function sendKeywordToAPI(keyword, clicked = false) {
  fetch('https://portal.simify.com/api/v2/webhooks/customEvent', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      eventSource: 'simify_web',
      eventType: 'search',
      additionalInfo: clicked ? `${keyword}; clicked` : keyword,
    }),
  }).catch(() => {}); // Silently ignore errors for analytics
}

$(document).ready(function () {
  $(document).on('click', 'a', function () {
    if ($(this).attr('href').includes('#')) {
      // var target = $(this).attr('href');
      var targetId = $(this).attr('href');
      var targetElement = $(targetId);
      // console.log()
      if (targetElement.length) {
        $('html, body').animate(
          {
            scrollTop: targetElement.offset().top - 250,
          },
          1000,
        ); // 1000 milliseconds = 1 second
      }
    }
  });
  setTimeout(function () {
    $('.Faq__Section-wrapper ul.Faq__Section li:first').addClass('active');
  }, 500); // OPTIMIZED: Reduced from 2000ms to 500ms for faster FAQ activation

  $(document).on(
    'click',
    '.travelex-image-with-image .works-video-img-wrapper, .sim-works-video-block .works-video-img-wrapper',
    function () {
      var $this = $(this);
      var video_src = $(this).siblings('.AspectRatio').find('iframe').attr('data-src');
      $(this).addClass('hide');
      // var player = $(this).siblings('.AspectRatio').find('iframe');
      $(this).siblings('.AspectRatio').find('iframe').attr('allow', 'autoplay;');
      $(this).siblings('.AspectRatio').find('iframe').attr('src', video_src);
    },
  );

  // Slick slider initialization moved to conditional loader
  // var insta_slider_length = $('.insta-slider').length;
  // if (insta_slider_length > 0) {
  //   $('.insta-slider').slick({
  //     dots: false,
  //     arrows: true,
  //     infinite: true,
  //     speed: 300,
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     responsive: [
  //       {
  //         breakpoint: 640,
  //         settings: {
  //           arrows: false,
  //         },
  //       },
  //     ],
  //   });
  // }

  $('.it-work-in__wrapper').on('click', function () {
    $('.link_Coverage').trigger('click');
  });

  $(window).on('load', function () {
    var pathname = window.location.pathname;
    //console.log('Path =',pathname);
    var hdr_height =
      parseInt($('.shopify-section--header header').height()) +
      parseInt($('.announce-main .AnnouncementBar').height());
    // 78 + 40 = 118

    // if (pathname == '/en-au'){
    //   var hdr_height = parseInt($('#shopify-section-header-au').height()) + parseInt($('.announce-main').height());
    // } else {
    //   var hdr_height = parseInt($('.shopify-section--header').height()) + parseInt($('.announce-main').height());
    // }
    // console.log('hdr_height =', hdr_height);
    $('#sidebar-menu').css('top', hdr_height);
    $(document).on('click', '.Header__Icon[data-drawer-id="sidebar-menu"]', function () {
      $('.PageOverlay.sidebarmenu-bg').css('top', hdr_height);
    });
  });

  if ($('.template-collection').length > 0) {
    const tabsBtns = Array.from(document.querySelectorAll('[data-tab-id]'));
    const tabs = Array.from(document.querySelectorAll('[data-tab]'));

    // console.log('tabsBtns', tabsBtns);

    if (tabsBtns != undefined) {
      if (tabsBtns.length > 0) {
        let selectedTab = tabsBtns[1].dataset.tabId;

        const hideTabs = () => {
          tabs
            .filter((tab) => tab.dataset.tab !== selectedTab)
            .forEach((tab) => {
              tab.classList.add('tabs__tab--hide');
            });

          tabsBtns
            .filter((tab) => tab.dataset.tabId !== selectedTab)
            .forEach((tab) => {
              tab.classList.add('tabs__tab-btn--not-selected');
            });
        };
        hideTabs();

        const handleSelectTab = (e) => {
          selectedTab = e.target.dataset.tabId;

          tabs.forEach((tab) => {
            tab.classList.remove('tabs__tab--hide');
          });

          tabsBtns.forEach((tab) => {
            tab.classList.remove('tabs__tab-btn--not-selected');
          });

          hideTabs();
        };

        tabsBtns.forEach((btn) => {
          btn.addEventListener('click', handleSelectTab);
        });

        $.fn.containClass = function (cssClass) {
          if (this.length > 1) {
            return;
          }
          return $(this).attr('class').indexOf(cssClass) > -1;
        };

        // hide/show when click on esims/sims tab on coll page
        $('.tabs__tab-btn').click(function () {
          var activeProd = $(this).data('tab-id');
          //console.log(activeProd, '<== curr coll activeProd');

          $('.CollectionMain')
            .find('.CollectionInner')
            .find('.ProductList')
            .find('.Grid__Cell')
            .hide();
          $('.CollectionMain').find('.Form__Select').hide();

          $(this)
            .closest('.CollectionMain')
            .find('.CollectionInner')
            .find('.ProductList')
            .find('.Grid__Cell.' + activeProd)
            .show();
          $(this)
            .closest('.CollectionMain')
            .find('.' + activeProd + '-where-select')
            .show();
        });

        if ($('.tabs__buttons--container').length) {
          if ($('body').containClass('esim')) {
            $('.tabs__tab-btn[data-tab-id="esim"]').trigger('click');
          } else {
            $('.tabs__tab-btn[data-tab-id="sim"]').trigger('click');
          }
        }
      }
    }
  }

  // Get currenct year for Footer.
  if ($('#currYear').length > 0) {
    $('#currYear').text(new Date().getFullYear());
  }
  $('.span_coverage').click(function () {
    $(this).closest('.new_pro-tab').find('.esim-tabs').find('.link_Coverage').trigger('click');
  });
  $('.which__countries-button').click(function () {
    $(this).closest('.new_pro-tab').find('.esim-tabs').find('.link_Coverage').trigger('click');
  });
  // Mobile Menu

  // $('.second-level .Collapsible.Collapsible_second .toggle-collapsible a.Collapsible__Button').click(function(){
  //  console.log('clicked');
  //   var status = $(this).attr('aria-expanded');
  //   if (status == 'true'){
  //     $(this).closest('.Collapsible_first').find('.Collapsible__Button').attr('aria-expanded','false');
  //   }
  // });

  $('.Collapsible_second .sidebar-menu-title.second > span.title').click(function (e) {
    //e.preventDefault();
    // console.log('2 click');
    $(this)
      .closest('.Collapsible_first')
      .find('.Collapsible__Button.has_child2')
      .attr('aria-expanded', 'false');
  });

  // $('.Collapsible__Button.has_child3').click(function(){
  //  console.log('clicked');
  //   var status = $(this).attr('aria-expanded');
  //   if (status == 'false'){
  //     $(this).attr('aria-expanded','true');
  //   }
  // });

  $('.Collapsible_third .sidebar-menu-title.third > span.title').click(function (e) {
    //e.preventDefault();
    var $this3 = $(this);
    // console.log('3 click', $this3.closest('li'));
    setTimeout(function () {
      //$this3.closest('li').find('.Collapsible__Button.has_child3').attr("aria-expanded","false");
      $this3.closest('ul').find('.Collapsible__Button.has_child3').attr('aria-expanded', 'false');
    }, 10); // OPTIMIZED: Reduced from 50ms to 10ms for faster menu responsiveness
    //$(this).closest('.Collapsible_first').find('.Collapsible__Button.has_child2').attr('aria-expanded', 'true');
  });

  $('.Drawer__Container button.has_child3[data-action="toggle-collapsible"]').click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', 'true');
  });

  $('.Drawer__Container .Collapsible_third ul li > a').click(function () {
    var $url = $(this).attr('href');
    // console.log('$url', $url);
    window.location = $url;
  });

  // Ends Mobile

  function change_position() {
    if ($(window).width() < 769) {
      $('.template-suffix-esim-new .new_pro-tab').insertAfter(
        '.template-suffix-esim-new .product_text_small',
      );
      $('.template-suffix-esim-unlimited .new_pro-tab').insertAfter(
        '.template-suffix-esim-unlimited .product_text_small',
      );

      $('.template-suffix-esim-unlimited-days-dropdown .new_pro-tab').insertAfter(
        '.template-suffix-esim-unlimited-days-dropdown .product_text_small',
      );
    } else {
      $('.template-suffix-esim-new .new_pro-tab').insertAfter(
        '.template-suffix-esim-new .new_pro-conent .product_text',
      );
      $('.template-suffix-esim-unlimited .new_pro-tab').insertAfter(
        '.template-suffix-esim-unlimited .new_pro-conent .is-my-device-compatible__block',
      );

      $('.template-suffix-esim-unlimited-days-dropdown .new_pro-tab').insertAfter(
        '.template-suffix-esim-unlimited-days-dropdown .new_pro-conent .is-my-device-compatible__block',
      );
    }
  }

  // change_position();

  // Debounced resize handler
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // change_position();
    }, 100); // OPTIMIZED: Reduced from 200ms to 100ms for faster responsive behavior
  });

  if (document.body.clientWidth < 769) {
    $('.template-suffix-esim-new-ab .new_pro-conent').insertAfter(
      '.template-suffix-esim-new-ab .product_text_small',
    );
    $('.template-suffix-esim-unlimited-ab .new_pro-conent').insertAfter(
      '.template-suffix-esim-unlimited-ab .product_text_small',
    );
  } else {
    $('.template-suffix-esim-new-ab .new_pro-conent').insertBefore(
      '.template-suffix-esim-new-ab .new_pro-grid',
    );
    $('.template-suffix-esim-unlimited-ab .new_pro-conent').insertBefore(
      '.template-suffix-esim-unlimited-ab .new_pro-grid',
    );
  }
}, 100);

// if( $(window).width() < 641 ){
//   $('.collection-template .ProductList').slick({
//     dots: true,
//     arrows: false,
//     infinite: false,
//     adaptiveHeight:true,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//   });
// }

if ($('#insta-feed').length > 0) {
  var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA();
    }, 400); // OPTIMIZED: Reduced from 800ms to 400ms for faster Instagram feed detection
  }
  ALAcheck();
  function customALA() {
    var $selector = $('#shopify-section-instafeed #insta-feed a').length;
    if ($selector > 0) {
      clearInterval(isALARendered);
      // Instagram feed Slick initialization moved to conditional loader
      // $('#insta-feed').slick({
      //   dots: false,
      //   arrows: true,
      //   infinite: true,
      //   speed: 300,
      //   slidesToShow: 3,
      //   slidesToScroll: 1,
      //   responsive: [
      //     {
      //       breakpoint: 641,
      //       settings: {
      //         dots: false,
      //         arrows: false,
      //         autoplay: true,
      //         autoplaySpeed: 5000,
      //       },
      //     },
      //   ],
      // });
    }
  }
}

$(document).on('click', '#cartform-drawer .esim-check', function () {
  $(this).parent().toggleClass('active');
});

// For Article page scroll
if ($('.progress-bar').length > 0) {
  function myPageScoll() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    document.getElementById('myBar').style.width = scrolled + '%';
  }
  window.onscroll = function () {
    myPageScoll();
  };
}

$(document).on('click', '.toggle', function (event) {
  event.preventDefault();
  var target = $(this).data('target');
  $('#' + target).toggleClass('hide');
});

$(document).on('click', '.toggle1', function (event) {
  event.preventDefault();
  var target = $(this).data('target');
  $('#' + target).toggleClass('hide1');
});

if ($('.ProductForm__AddToCart').length > 0) {
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var addtobtn = $('.ProductForm__AddToCart').offset().top + 70;
    if (scroll > addtobtn) {
      $('.product_fix_bar').addClass('active');
    } else {
      $('.active').removeClass('active');
    }
  });
  $('.product_fix_bar .Button').click(function () {
    $('.ProductForm__AddToCart').trigger('click');
  });
}

if ($('.shopify-section--product-template').length > 0) {
  $('.ProductItem__Wrap .QuantitySelector button').click(function () {
    setTimeout(function () {
      var $qtyval2 = $('.template-product')
        .find('.shopify-section--product-template')
        .find('.Product_Wrapper')
        .find('.ProductItem__Wrap')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('input')
        .val();
      $('.template-product')
        .find('.shopify-section--product-template')
        .find('.product_fix_bar')
        .find('.cart_right_btn')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('input')
        .val($qtyval2);
    }, 100); // OPTIMIZED: Reduced from 550ms to 100ms for faster quantity updates
  });

  $('.product_fix_bar .QuantitySelector button').click(function () {
    if ($(this).hasClass('qtyminus')) {
      $(this)
        .closest('.template-product')
        .find('.shopify-section--product-template')
        .find('.Product_Wrapper')
        .find('.ProductItem__Wrap')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('button[data-action="decrease-quantity"]')
        .trigger('click');
    } else {
      $(this)
        .closest('.template-product')
        .find('.shopify-section--product-template')
        .find('.Product_Wrapper')
        .find('.ProductItem__Wrap')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('button[data-action="increase-quantity"]')
        .trigger('click');
    }
    var $qtyval1 = $('.template-product')
      .find('.shopify-section--product-template')
      .find('.Product_Wrapper')
      .find('.ProductItem__Wrap')
      .find('.ProductForm__QuantitySelector')
      .find('.QuantitySelector')
      .find('input')
      .val();
    $('.template-product')
      .find('.shopify-section--product-template')
      .find('.product_fix_bar')
      .find('.cart_right_btn')
      .find('.ProductForm__QuantitySelector')
      .find('.QuantitySelector')
      .find('input')
      .val($qtyval1);
  });
}

$('.add_products input').click(function () {
  $(this).parents('.add_products').toggleClass('selected');
  var id = $(this).parents('.add_products').data('id');
  var name = $(this).parents('.add_products').data('name');
  var val = $(this).parents('.add_products').data('val');
  if ($(this).parents('.add_products').hasClass('selected')) {
    $(".add_products[data-id='" + id + "']").append(
      '<input type="hidden" id="' + id + '" name="properties[' + name + ']" value="' + val + '">',
    );
  } else {
    $(this).parents('.add_products').find('input[type="hidden"]').remove();
  }

  var prdct_price = '';
  var pluspro_price = '';
  var prdct_main_price = $('.ProductMeta__PriceList .ProductMeta__Price.Price').attr('data-price');

  if ($(this).parents('.add_products').hasClass('selected')) {
    prdct_price = $(this)
      .parents('.add_products')
      .find('.add_products_item .prdct-price')
      .data('price');
    pluspro_price = parseInt(prdct_price) + parseInt(prdct_main_price);
  } else {
    prdct_price = $(this)
      .parents('.add_products')
      .find('.add_products_item .prdct-price')
      .data('price');
    pluspro_price = parseInt(prdct_main_price) - parseInt(prdct_price);
  }
  var format_price = Shopify.formatMoney(pluspro_price, window.theme.moneyFormat);
  $('.ProductMeta__PriceList .ProductMeta__Price.Price').attr('data-price', pluspro_price);
  $('.ProductMeta__PriceList .ProductMeta__Price.Price').html(format_price.split('.')[0]);
});

if ($('.ProductForm__AddToCart').length > 0) {
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var addtobtn = $('.ProductForm__AddToCart').offset().top + 70;
    if (scroll > addtobtn) {
      $('.product_fix_bar').addClass('active');
    } else {
      $('.active').removeClass('active');
    }
  });

  $('.product_fix_bar .Button').click(function () {
    $('.ProductForm__AddToCart').trigger('click');
  });
}

if ($('.shopify-section--product-template').length > 0) {
  $('.ProductItem__Wrap .QuantitySelector button').click(function () {
    setTimeout(function () {
      if ($('.Product_Wrapper').length > 0) {
        var $qtyval2 = $('.template-product')
          .find('.shopify-section--product-template')
          .find('.Product_Wrapper')
          .find('.ProductItem__Wrap')
          .find('.ProductForm__QuantitySelector')
          .find('.QuantitySelector')
          .find('input')
          .val();
      }
      if ($('.new_Product_Wrapper').length > 0) {
        var $qtyval2 = $('.template-product')
          .find('.shopify-section--product-template')
          .find('.new_Product_Wrapper')
          .find('.ProductItem__Wrap')
          .find('.ProductForm__QuantitySelector')
          .find('.QuantitySelector')
          .find('input')
          .val();
      }
      $('.template-product')
        .find('.shopify-section--product-template')
        .find('.product_fix_bar')
        .find('.cart_right_btn')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('input')
        .val($qtyval2);
    }, 100); // OPTIMIZED: Reduced from 550ms to 100ms for faster quantity updates
  });

  $('.product_fix_bar .QuantitySelector button').click(function () {
    if ($(this).hasClass('qtyminus')) {
      if ($('.Product_Wrapper').length > 0) {
        $(this)
          .closest('.template-product')
          .find('.shopify-section--product-template')
          .find('.Product_Wrapper')
          .find('.ProductItem__Wrap')
          .find('.ProductForm__QuantitySelector')
          .find('.QuantitySelector')
          .find('button[data-action="decrease-quantity"]')
          .trigger('click');
      }
      if ($('.new_Product_Wrapper').length > 0) {
        $(this)
          .closest('.template-product')
          .find('.shopify-section--product-template')
          .find('.new_Product_Wrapper')
          .find('.ProductItem__Wrap')
          .find('.ProductForm__QuantitySelector')
          .find('.QuantitySelector')
          .find('button[data-action="decrease-quantity"]')
          .trigger('click');
      }
    } else {
      if ($('.Product_Wrapper').length > 0) {
        $(this)
          .closest('.template-product')
          .find('.shopify-section--product-template')
          .find('.Product_Wrapper')
          .find('.ProductItem__Wrap')
          .find('.ProductForm__QuantitySelector')
          .find('.QuantitySelector')
          .find('button[data-action="increase-quantity"]')
          .trigger('click');
      }
      if ($('.new_Product_Wrapper').length > 0) {
        $(this)
          .closest('.template-product')
          .find('.shopify-section--product-template')
          .find('.new_Product_Wrapper')
          .find('.ProductItem__Wrap')
          .find('.ProductForm__QuantitySelector')
          .find('.QuantitySelector')
          .find('button[data-action="increase-quantity"]')
          .trigger('click');
      }
    }
    if ($('.Product_Wrapper').length > 0) {
      var $qtyval1 = $('.template-product')
        .find('.shopify-section--product-template')
        .find('.Product_Wrapper')
        .find('.ProductItem__Wrap')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('input')
        .val();
      $('.template-product')
        .find('.shopify-section--product-template')
        .find('.product_fix_bar')
        .find('.cart_right_btn')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('input')
        .val($qtyval1);
    }
    if ($('.new_Product_Wrapper').length > 0) {
      var $new_qtyval1 = $('.template-product')
        .find('.shopify-section--product-template')
        .find('.new_Product_Wrapper')
        .find('.ProductItem__Wrap')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('input')
        .val();
      $('.template-product')
        .find('.shopify-section--product-template')
        .find('.product_fix_bar')
        .find('.cart_right_btn')
        .find('.ProductForm__QuantitySelector')
        .find('.QuantitySelector')
        .find('input')
        .val($new_qtyval1);
    }
  });
}

//   $("form[action='/cart'] [type=submit]").on("click", function(e) {
//     e.preventDefault();
//     console.log('nai jawaa dev');
//     var formIsValid = true;
//     $('.required.date').each(function() {
//       var err = $(this).attr('id') + '-error';
//       $("." + err).hide();
//       $(this).removeClass('error');
//       if (formIsValid && $(this).val() == '') {
//         formIsValid = false;
//         $(this).addClass('error');
//         $("." + err).show();
//       }
//     });
//     if (formIsValid){
//       $(this).submit();
//     } else {
//       e.preventDefault();
//       return false;
//     }
//  });
if ($('.shopify-section--refer .Button--Fancy').length > 0) {
  $('.Button--Fancy').click(function (e) {
    StampedFn.toggleRewardsModal();
    e.preventDefault();
  });
}

if ($(window).width() < 641) {
  if ($('.Footer__Block.Footer__Block--links').length > 0) {
    $('.Footer__Title.Heading').click(function () {
      $(this).closest('.Footer__Block.Footer__Block--links').toggleClass('active');
    });
  }
}

// $('.ProductForm__Variants .SizeSwatchList .HorizontalList__Item [type="checkbox"]').change(function() {
//   console.log($(this).val(),'check');
//   if($(this).val() != 'None'){
//     if($(this).is(":checked")) {
//       $(this).siblings('[type="radio"]').trigger('click');
//       console.log('if');
//     }else{
//       $(this).parents('.SizeSwatchList').find(':radio[value="None"]').trigger('click');
//       console.log('else');
//     }
//   }
// });
// Announce sticky
//   if($(".announce-main").hasClass('announce-sticky')){
//     $('body').addClass('stuck-announce');
//     var divHeight = $('.announce-main').height();
//     $('.shopify-section--header').css('top', divHeight+'px');
//   }

$('.ProductForm__Variants .SizeSwatchList .HorizontalList__Item [type="checkbox"]').change(
  function () {
    //console.log($(this).val(),'check');
    var vid = $(this).data('vid');
    var specListArr = $(this).data('speclistarr');
    if ($(this).val() != 'None') {
      if ($(this).is(':checked')) {
        $(this).siblings('[type="checkbox"]').trigger('click');
        $(this).siblings('[type="radio"]').trigger('click');
        //console.log('if');

        // change the property values as per curr variant for special checks list.
        $(this)
          .closest('.ProductForm')
          .find('input[name="properties[_spec_check]"]')
          .val(specListArr);

        //$(this).closest('.shopify-section--product-template').find('.new_Product_Wrapper').find('.new_Product-inner').find('.ProductItem__Wrap').find('.ProductForm').find('.ProductForm__Variants').find('.SizeSwatchList')
        $(this)
          .closest('.shopify-section--product-template')
          .find('.product_fix_bar')
          .find('#fix_bar_vatiants')
          .val(vid)
          .trigger('change');
        // $('.ProductForm').find('.ProductForm__Variants').find('.ProductForm__Option select').val(vid).trigger('change');
      } else {
        $(this).parents('.SizeSwatchList').find(':radio[value="None"]').trigger('click');
        //console.log('else');
      }
    }
    var disc_code_price = $(this)
      .closest('.HorizontalList__Item')
      .find('.pdp-cmp-price')
      .find('p')
      .text();
    // console.log('disc_code_price = ',disc_code_price);
    $(this)
      .closest('form')
      .find('.ProductForm__AddToCart')
      .find('span[data-money-convertible]')
      .text(disc_code_price);

    $(this)
      .closest('.shopify-section--product-template')
      .find('.product_fix_bar')
      .find('.price')
      .text(disc_code_price);
  },
);

$('.ProductForm__Variants .SizeSwatchList .HorizontalList__Item [type="radio"]').change(
  function () {
    //console.log($(this).val(),'check');
    var vid = $(this).data('vid');
    var specListArr = $(this).data('speclistarr');
    if ($(this).val() != 'None') {
      if ($(this).is(':checked')) {
        $(this).siblings('[type="checkbox"]').trigger('click');
        $(this).siblings('[type="radio"]').trigger('click');
        //console.log('if');

        // change the property values as per curr variant for special checks list.
        $(this)
          .closest('.ProductForm')
          .find('input[name="properties[_spec_check]"]')
          .val(specListArr);

        //$(this).closest('.shopify-section--product-template').find('.new_Product_Wrapper').find('.new_Product-inner').find('.ProductItem__Wrap').find('.ProductForm').find('.ProductForm__Variants').find('.SizeSwatchList')
        $(this)
          .closest('.shopify-section--product-template')
          .find('.product_fix_bar')
          .find('#fix_bar_vatiants')
          .val(vid)
          .trigger('change');
        // $('.ProductForm').find('.ProductForm__Variants').find('.ProductForm__Option select').val(vid).trigger('change');
      } else {
        $(this).parents('.SizeSwatchList').find(':radio[value="None"]').trigger('click');
        //console.log('else');
      }
    }
    var disc_code_price = $(this)
      .closest('.HorizontalList__Item')
      .find('.pdp-cmp-price')
      .find('p')
      .text();
    // console.log('disc_code_price = ',disc_code_price);
    $(this)
      .closest('form')
      .find('.ProductForm__AddToCart')
      .find('span[data-money-convertible]')
      .text(disc_code_price);

    $(this)
      .closest('.shopify-section--product-template')
      .find('.product_fix_bar')
      .find('.price')
      .text(disc_code_price);
  },
);

//if( $('.pro_usa-t-mobile-travel-esim-unlimited-data-calls-texts-30-days').length == 0 ){
if ($('.template-suffix-esim').length > 0) {
  $('.SizeSwatchList .SizeSwatch').click(function () {
    $(this).closest('.HorizontalList__Item').find('input[type="radio"]').trigger('click');
    $(this).closest('.HorizontalList__Item').find('input[type="checkbox"]').trigger('click');
  });
}

// fix_bar_vatiants
$('#fix_bar_vatiants').change(function () {
  var currVal = $(this).find('option:selected').val();
  //console.log('fix_bar=>',currVal);
  $(this)
    .closest('.shopify-section--product-template')
    .find('.new_Product_Wrapper')
    .find('.new_Product-inner')
    .find('.ProductItem__Wrap')
    .find('.ProductForm')
    .find('.ProductForm__Variants')
    .find('.SizeSwatchList')
    .find('input[type="checkbox"][data-vid="' + currVal + '"]')
    .trigger('click');
  $(this)
    .closest('.shopify-section--product-template')
    .find('.new_Product_Wrapper')
    .find('.new_Product-inner')
    .find('.ProductItem__Wrap')
    .find('.ProductForm')
    .find('.ProductForm__Variants')
    .find('.SizeSwatchList')
    .find('input[type="radio"][data-vid="' + currVal + '"]')
    .trigger('click');
});

if ($('.esim-faq-around .esim-que').length == 0) {
  $('#shopify-section-e-sim-faq').hide();
}

$('.set > a').on('click', function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).siblings('.content').slideUp(200);
    $('.set > a i').removeClass('fa-minus').addClass('fa-plus');
  } else {
    $('.set > a i').removeClass('fa-minus').addClass('fa-plus');
    $(this).find('i').removeClass('fa-plus').addClass('fa-minus');
    $('.set > a').removeClass('active');
    $(this).addClass('active');
    $('.content').slideUp(200);
    $(this).siblings('.content').slideDown(200);
  }
});

$('.set > h3').on('click', function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).siblings('.content').slideUp(200);
    $('.set > h3 i').removeClass('fa-minus').addClass('fa-plus');
  } else {
    $('.set > h3 i').removeClass('fa-minus').addClass('fa-plus');
    $(this).find('i').removeClass('fa-plus').addClass('fa-minus');
    $('.set > h3').removeClass('active');
    $(this).addClass('active');
    $('.content').slideUp(200);
    $(this).siblings('.content').slideDown(200);
  }
});

$(document).ready(function () {
  setTimeout(function () {
    $('#shopify-section-SEO_Collections_FAQs .Faq__Question').click(function () {
      // console.log('hhhhhcustom');
      $(this).next().toggleClass('height_auto');
      $(this)
        .closest('.Faq__Item')
        .attr('aria-expanded', function (i, attr) {
          return attr == 'true' ? 'false' : 'true';
        });
    });
  }, 1000); // OPTIMIZED: Reduced from 3500ms to 1000ms for much faster FAQ functionality
});

$('ul.esim-tabs li').click(function () {
  var tab_id = $(this).attr('data-tab');
  $(this).closest('div').find('ul.esim-tabs li').removeClass('current');
  $(this).closest('div').find('.tab-content').removeClass('current');
  $(this).addClass('current');
  $('#' + tab_id).addClass('current');
});

// Why eSIM around Slick initialization moved to conditional loader
// if ($(window).width() <= 768) {
//   $('.why-esim-around').slick({
//     dots: false,
//     arrows: false,
//     infinite: true,
//     centerMode: true,
//     centerPadding: '100px',
//     slidesToShow: 1,
//     slidesToScroll: 3,
//   });
// }

//Ak custom code
$('.esim-work-wrapper .popup_link').on('click', function () {
  $('.compatible_works_video_popup .custom-model-main').addClass('model-open');
  $('.esim-compatible .custom-model-main').addClass('model-open');
});
//End Ak custom code

$('.esim-compatible-inner .popup_link').on('click', function () {
  $('#shopify-section-esim-compatible .custom-model-main').addClass('model-open');
  $('.esim-compatible .custom-model-main').addClass('model-open');
});
$('.popup_link').on('click', function () {
  $('#shopify-section-esim-compatible .custom-model-main').addClass('model-open');
  $('.esim-compatible .custom-model-main').addClass('model-open');
});
$('.close-btn, .bg-overlay').click(function () {
  $('#shopify-section-esim-compatible .custom-model-main').removeClass('model-open');
  $('.compatible_works_video_popup .custom-model-main').removeClass('model-open');
  $('.esim-compatible .custom-model-main').removeClass('model-open');
});
$('.popup_link_how').on('click', function () {
  $('.new-popup .custom-model-main').addClass('model-open');
  $('body').addClass('no-scroll');
});
$('.close-btn, .bg-overlay').click(function () {
  $('.new-popup .custom-model-main').removeClass('model-open');
  $('body').removeClass('no-scroll');
});

function searchModel(element) {
  const filter = element.value.toUpperCase();
  const listItems = document.querySelectorAll('#modelList li:not(.title)');
  let hasMatch = false;

  listItems.forEach((item) => {
    const span = item.querySelector('span');
    const text = span ? span.textContent.toUpperCase() : '';

    if (text.includes(filter)) {
      item.style.display = '';
      hasMatch = true;
    } else {
      item.style.display = 'none';
    }
  });

  // Show or hide all title elements based on matches
  const titles = document.querySelectorAll('.pop-up-content-wrap .title');
  titles.forEach((title) => {
    title.style.display = hasMatch ? '' : 'none';
  });

  // Delay for search result grouping logic
  setTimeout(searchResult, 100); // OPTIMIZED: Reduced from 250ms to 100ms for faster search functionality

  function searchResult() {
    const allItems = document.querySelectorAll('#modelList li');
    allItems.forEach((item) => {
      if (item.classList.contains('title')) {
        item.style.display = 'none';
      }
    });

    allItems.forEach((item, index) => {
      if (!item.classList.contains('title') && item.style.display !== 'none') {
        for (let i = index - 1; i >= 0; i--) {
          const prev = allItems[i];
          if (prev.classList.contains('title')) {
            prev.style.display = '';
            break;
          }
        }
      }
    });
  }
}

// Page sim-activation-register
if (
  $('.template-suffix-sim-activation-register').length > 0 ||
  $('.template-suffix-sim-activation').length > 0 ||
  $('.template-suffix-amzon-sim-activation').length > 0
) {
  setTimeout(function () {
    document.getElementById('md-app-embed__modal').style.display = 'none';
    document.getElementById('md-app-embed__modal').style.visibility = 'hidden';
  }, 500); // OPTIMIZED: Reduced from 1500ms to 500ms for faster modal hiding
}

const accordionBtns = document.querySelectorAll('.accordion');

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle('is-open');
    let content = this.nextElementSibling;
    // console.log(content);
    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + 'px';
      // console.log(content.style.maxHeight);
    }
  };
});

/* Menu - Cart button click to open and close the prev opened drawer */
$(document).on('click', '.Header__Icon[data-drawer-id="sidebar-menu"]', function () {
  $('body').find('.PageOverlay').addClass('sidebarmenu-bg');
  $('.Drawer__Close[data-action="close-drawer"][data-drawer-id="sidebar-cart"]').click();
});

$(document).on(
  'click',
  '.Icon-Wrapper--clickable[data-action="close-drawer"][data-drawer-id="sidebar-menu"]',
  function () {
    // console.log('Icon-Wrapper-close - click');
    $('body').find('.PageOverlay').removeClass('sidebarmenu-bg');
  },
);

$(document).on(
  'click',
  '.Header--initialized .Header__Icon[href="/cart"][data-action="open-drawer"],.Header--initialized .Header__Icon[href="/en-au/cart"][data-action="open-drawer"]',
  function () {
    // console.log('Header--initialized - cart - click');
    $(
      '.Icon-Wrapper--clickable[data-action="close-drawer"][data-drawer-id="sidebar-menu"]',
    ).click();
    $('body').find('.PageOverlay').addClass('is-visible');
  },
);

$(document).ready(function () {
  function searchList($this) {
    var selid = 'searchCollList';
    var values = {};
    // $.each($("#"+selid).prop("options"), function(i, opt) {
    $.each($($this).siblings('#searchCollList').prop('options'), function (i, opt) {
      // values[opt.value] = opt.textContent;

      values[opt.value] = {
        textContent: opt.textContent,
        imgUrl: $(opt).data('img-url'),
        imghas: $(opt).data('img-has'),
      };
    });
    //$( "select#"+selid).replaceWith( "<div id="+selid+"></div>" );

    $('.search_result').html('');

    // Liv note : adding a border here?
    $('.search_result').append('<li class="title">Popular Destinations</li>');
    $.each(values, function (k, v) {
      if (v.imgUrl) {
        if (v.imghas != 'EmptyDrop') {
          $('.search_result').append(
            '<li><a href="' +
              k +
              '"><img src="' +
              v.imgUrl +
              '" width="24" height="24"/>' +
              '<span>' +
              v.textContent +
              '</span>' +
              '</a></li>',
          );
        } else {
          $('.search_result').append(
            '<li><a href="' + k + '">' + '<span>' + v.textContent + '</span>' + '</a></li>',
          );
        }
      } else {
        $('.search_result').append(
          '<li><a href="' + k + '">' + '<span>' + v.textContent + '</span>' + '</a></li>',
        );
      }
    });
  }
  //searchList();
  // console.log('Search JSON =>', resultJson);

  $('.search_product:not(.header_search)').click(function () {
    if ($(this).siblings('.search_result').children().length > 0) {
      $(this).siblings('.search_result').addClass('tw:border');
    }
    if ($(this).val().length == 0) {
      var $this = $(this);
      searchList($this);
      if ($(this).siblings('.search_result').children().length > 0) {
        $(this).siblings('.search_result').addClass('tw:border');
      }
    }
  });
  // $(".search_product").click(function(){
  //   console.log('hhh')
  //   if ( $(this).val().length == 0){
  //     searchList();
  //   }
  // });

  $('.search_product').on('focus', function () {
    $(this).addClass('placeholder-active');
  });
  $('.search_product').on('blur', function () {
    $(this).removeClass('placeholder-active');
  });

  let searchTimer;
  $('.search_product').on('keyup', function () {
    var $this = $(this);
    //console.log($this.val().length);
    var currency = $('select#currency option:selected').attr('data-country');
    if (currency.includes('en')) {
      var url = currency;
    }
    var searchResultHtml = '';
    if ($this.val().length == 0) {
      if (!$(this).hasClass('header_search')) {
        searchList($this);
      } else {
        $('.search_result').html('');
      }
    }

    clearTimeout(searchTimer); // Clear previous timer if they type again

    let search_value = $(this).val();

    if (search_value.length >= 3) {
      searchTimer = setTimeout(() => {
        sendKeywordToAPI(search_value);
      }, 1000); // OPTIMIZED: Reduced from 3000ms to 1000ms for faster search analytics
    }

    var search_result_container = $(this).siblings('.search_result');
    if ($(this).val().length == 0) {
      if ($(this).hasClass('header_search')) {
        search_result_container.removeClass('tw:border');
      }
    } else {
      search_result_container.addClass('tw:border');
    }

    if ($this.val().length > 0) {
      // console.log($(this).val());
      var searchVal = $(this).val().toLowerCase();
      // console.log('searchVal', searchVal);
      searchResultHtml += '<ul>';
      var region_match = false;

      searchResultHtml += '<li class="title country_title">Country</li>';
      var regions_old = [];

      for (var i = 0; i < resultJson.length; i++) {
        for (var j = 0; j < resultJson[i].country.length; j++) {
          if (resultJson[i].country[j].search_title.toLowerCase().startsWith(searchVal)) {
            regions_old.push(resultJson[i].country[j].search_title);
            // alert('Match found!');
            // If you want to break out of the loop after the first match is found, you can use `break;` here
            if (url) {
              if (resultJson[i].country[j].icon_url) {
                searchResultHtml +=
                  '<li class="country_li" ><a href="' +
                  url +
                  resultJson[i].country[j].url +
                  '"><img src="' +
                  resultJson[i].country[j].icon_url +
                  '" width="24px" height="24px"/>' +
                  resultJson[i].country[j].title +
                  '</a></li>';
              } else {
                searchResultHtml +=
                  '<li class="country_li" ><a href="' +
                  url +
                  resultJson[i].country[j].url +
                  '">' +
                  resultJson[i].country[j].title +
                  '</a></li>';
              }
            } else {
              if (resultJson[i].country[j].icon_url) {
                searchResultHtml +=
                  '<li class="country_li" ><a href="' +
                  resultJson[i].country[j].url +
                  '"><img src="' +
                  resultJson[i].country[j].icon_url +
                  '" width="24px" height="24px"/>' +
                  resultJson[i].country[j].title +
                  '</a></li>';
              } else {
                searchResultHtml +=
                  '<li class="country_li" ><a href="' +
                  resultJson[i].country[j].url +
                  '">' +
                  resultJson[i].country[j].title +
                  '</a></li>';
              }
            }
          }
          // if(resultJson[i].country[j].search_title.indexOf(searchVal) > -1){
          //     if(url){
          //       searchResultHtml += '<li class="country_li" ><a href="'+url+resultJson[i].country[j].url+'">'+resultJson[i].country[j].title+'</a></li>';
          //     }else{
          //       searchResultHtml += '<li class="country_li" ><a href="'+resultJson[i].country[j].url+'">'+resultJson[i].country[j].title+'</a></li>';
          //     }
          // }
        }
      }
      for (var i = 0; i < resultJson.length; i++) {
        for (var j = 0; j < resultJson[i].country.length; j++) {
          if (resultJson[i].country[j].search_title.indexOf(searchVal) > -1) {
            if (!regions_old.includes(resultJson[i].country[j].search_title)) {
              regions_old.push(resultJson[i].country[j].search_title);
              if (url) {
                if (resultJson[i].country[j].icon_url) {
                  searchResultHtml +=
                    '<li class="country_li" ><a href="' +
                    url +
                    resultJson[i].country[j].url +
                    '"><img src="' +
                    resultJson[i].country[j].icon_url +
                    '" width="24px" height="24px"/>' +
                    resultJson[i].country[j].title +
                    '</a></li>';
                } else {
                  searchResultHtml +=
                    '<li class="country_li" ><a href="' +
                    url +
                    resultJson[i].country[j].url +
                    '">' +
                    resultJson[i].country[j].title +
                    '</a></li>';
                }
              } else {
                if (resultJson[i].country[j].icon_url) {
                  searchResultHtml +=
                    '<li class="country_li" ><a href="' +
                    resultJson[i].country[j].url +
                    '"><img src="' +
                    resultJson[i].country[j].icon_url +
                    '" width="24px" height="24px"/>' +
                    resultJson[i].country[j].title +
                    '</a></li>';
                } else {
                  searchResultHtml +=
                    '<li class="country_li" ><a href="' +
                    resultJson[i].country[j].url +
                    '">' +
                    resultJson[i].country[j].title +
                    '</a></li>';
                }
              }
            }
          }
        }
      }
      var regions = [];
      searchResultHtml += '<li class="title reg_title">Region</li>';
      for (var i = 0; i < resultJson.length; i++) {
        // if(resultJson[i].name == searchVal) {
        // if( resultJson[i].name.indexOf(searchVal) > -1 ) {

        //with starting string
        if (resultJson[i].name.toLowerCase().startsWith(searchVal)) {
          // region_match = true;
          if (resultJson[i].regional) {
            $.each(resultJson[i].regional, function (index, value) {
              if (regions.length > 0) {
                if (!regions.includes(value.search_title)) {
                  regions.push(value.search_title);
                  if (url) {
                    if (value.icon_url) {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        url +
                        value.url +
                        '"><img src="' +
                        value.icon_url +
                        '" width="24px" height="24px"/>' +
                        value.title +
                        '</a></li>';
                    } else {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        url +
                        value.url +
                        '">' +
                        value.title +
                        '</a></li>';
                    }
                  } else {
                    if (value.icon_url) {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        value.url +
                        '"><img src="' +
                        value.icon_url +
                        '" width="24px" height="24px"/>' +
                        value.title +
                        '</a></li>';
                    } else {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        value.url +
                        '">' +
                        value.title +
                        '</a></li>';
                    }
                  }
                }
              } else {
                regions.push(value.search_title);
                if (url) {
                  if (value.icon_url) {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      url +
                      value.url +
                      '"><img src="' +
                      value.icon_url +
                      '"  width="24px" height="24px"/>' +
                      value.title +
                      '</a></li>';
                  } else {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      url +
                      value.url +
                      '">' +
                      value.title +
                      '</a></li>';
                  }
                } else {
                  if (value.icon_url) {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      value.url +
                      '"><img src="' +
                      value.icon_url +
                      '"  width="24px" height="24px"/>' +
                      value.title +
                      '</a></li>';
                  } else {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      value.url +
                      '">' +
                      value.title +
                      '</a></li>';
                  }
                }
              }

              // if(value.icon_url){
              //   searchResultHtml += '<li class="region_li" data-title="'+value.search_title+'"><a href="'+value.url+'"><img src="'+value.icon_url+'"/>'+value.title+'</a></li>';
              // }else{
              //   searchResultHtml += '<li class="region_li" data-title="'+value.search_title+'"><a href="'+value.url+'">'+value.title+'</a></li>';
              // }
            });
          }
        }
      }

      for (var i = 0; i < resultJson.length; i++) {
        //with any letter
        if (resultJson[i].name.indexOf(searchVal) > -1) {
          // region_match = true;
          if (resultJson[i].regional) {
            $.each(resultJson[i].regional, function (index, value) {
              if (regions.length > 0) {
                if (!regions.includes(value.search_title)) {
                  regions.push(value.search_title);
                  if (url) {
                    if (value.icon_url) {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        url +
                        value.url +
                        '"><img src="' +
                        value.icon_url +
                        '"  width="24px" height="24px"/>' +
                        value.title +
                        '</a></li>';
                    } else {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        url +
                        value.url +
                        '">' +
                        value.title +
                        '</a></li>';
                    }
                  } else {
                    if (value.icon_url) {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        value.url +
                        '"><img src="' +
                        value.icon_url +
                        '"  width="24px" height="24px"/>' +
                        value.title +
                        '</a></li>';
                    } else {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        value.url +
                        '">' +
                        value.title +
                        '</a></li>';
                    }
                  }
                }
              } else {
                regions.push(value.search_title);
                if (url) {
                  if (value.icon_url) {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      url +
                      value.url +
                      '"><img src="' +
                      value.icon_url +
                      '"  width="24px" height="24px"/>' +
                      value.title +
                      '</a></li>';
                  } else {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      url +
                      value.url +
                      '">' +
                      value.title +
                      '</a></li>';
                  }
                } else {
                  if (value.icon_url) {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      value.url +
                      '"><img src="' +
                      value.icon_url +
                      '"  width="24px" height="24px"/>' +
                      value.title +
                      '</a></li>';
                  } else {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      value.url +
                      '">' +
                      value.title +
                      '</a></li>';
                  }
                }
              }
            });
          }
        }
      }
      for (var i = 0; i < resultJson.length; i++) {
        for (var j = 0; j < resultJson[i].country.length; j++) {
          if (resultJson[i].country[j].search_title.toLowerCase().startsWith(searchVal)) {
            // if(resultJson[i].country[j].search_title.indexOf(searchVal) > -1){

            $.each(resultJson[i].regional, function (index, value) {
              if (regions.length > 0) {
                if (!regions.includes(value.search_title)) {
                  regions.push(value.search_title);
                  if (url) {
                    if (value.icon_url) {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        url +
                        value.url +
                        '"><img src="' +
                        value.icon_url +
                        '"  width="24px" height="24px"/>' +
                        value.title +
                        '</a></li>';
                    } else {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        url +
                        value.url +
                        '">' +
                        value.title +
                        '</a></li>';
                    }
                  } else {
                    if (value.icon_url) {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        value.url +
                        '"><img src="' +
                        value.icon_url +
                        '"  width="24px" height="24px"/>' +
                        value.title +
                        '</a></li>';
                    } else {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        value.url +
                        '">' +
                        value.title +
                        '</a></li>';
                    }
                  }
                }
              } else {
                regions.push(value.search_title);
                if (url) {
                  if (value.icon_url) {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      url +
                      value.url +
                      '"><img src="' +
                      value.icon_url +
                      '"  width="24px" height="24px"/>' +
                      value.title +
                      '</a></li>';
                  } else {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      url +
                      value.url +
                      '">' +
                      value.title +
                      '</a></li>';
                  }
                } else {
                  if (value.icon_url) {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      value.url +
                      '"><img src="' +
                      value.icon_url +
                      '"  width="24px" height="24px"/>' +
                      value.title +
                      '</a></li>';
                  } else {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      value.url +
                      '">' +
                      value.title +
                      '</a></li>';
                  }
                }
              }
            });
          }
          if (resultJson[i].country[j].search_title.indexOf(searchVal) > -1) {
            $.each(resultJson[i].regional, function (index, value) {
              if (regions.length > 0) {
                if (!regions.includes(value.search_title)) {
                  regions.push(value.search_title);
                  if (url) {
                    if (value.icon_url) {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        url +
                        value.url +
                        '"><img src="' +
                        value.icon_url +
                        '"  width="24px" height="24px"/>' +
                        value.title +
                        '</a></li>';
                    } else {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        url +
                        value.url +
                        '">' +
                        value.title +
                        '</a></li>';
                    }
                  } else {
                    if (value.icon_url) {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        value.url +
                        '"><img src="' +
                        value.icon_url +
                        '"  width="24px" height="24px"/>' +
                        value.title +
                        '</a></li>';
                    } else {
                      searchResultHtml +=
                        '<li class="region_li" data-title="' +
                        value.search_title +
                        '"><a href="' +
                        value.url +
                        '">' +
                        value.title +
                        '</a></li>';
                    }
                  }
                }
              } else {
                regions.push(value.search_title);
                if (url) {
                  if (value.icon_url) {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      url +
                      value.url +
                      '"><img src="' +
                      value.icon_url +
                      '"  width="24px" height="24px"/>' +
                      value.title +
                      '</a></li>';
                  } else {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      url +
                      value.url +
                      '">' +
                      value.title +
                      '</a></li>';
                  }
                } else {
                  if (value.icon_url) {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      value.url +
                      '"><img src="' +
                      value.icon_url +
                      '"  width="24px" height="24px"/>' +
                      value.title +
                      '</a></li>';
                  } else {
                    searchResultHtml +=
                      '<li class="region_li" data-title="' +
                      value.search_title +
                      '"><a href="' +
                      value.url +
                      '">' +
                      value.title +
                      '</a></li>';
                  }
                }
              }
            });
          }
        }
      }

      searchResultHtml += '</ul>';

      $(this).siblings('.search_result').html(searchResultHtml);

      if ($(this).siblings('.search_result').find('.region_li').length < 1) {
        $(this).siblings('.search_result').find('.reg_title').remove();
      } else {
        $(this).siblings('.search_result').find('.reg_title:gt(0)').remove();
      }
      if ($(this).siblings('.search_result').find('.country_li').length < 1) {
        $(this).siblings('.search_result').find('.country_title').remove();
      } else {
        $(this).siblings('.search_result').find('.country_title:gt(0)').remove();
        // $('.country_title:gt(0)').remove();
      }

      var region_length = $(this).siblings('.search_result').find('.region_li').length;
      var country_length = $(this).siblings('.search_result').find('.country_li').length;
      if (region_length < 1 && country_length < 1) {
        var searchResultHtml_no =
          '<div class="no_results"><p>No results. Try searching another country or region.</p></div>';
        $(this).siblings('.search_result').html(searchResultHtml_no);
      }

      // li click
      // $('.search_result ul li a').on('click', function(){
      //   var search_value = $(this).parents('.search_result').siblings('.search_product').val();
      //   var keyword_length = search_value.length;
      //   if(keyword_length >= 3){
      //     const url = 'https://apps.simsdirect.com.au/esimproduct/public/api/keywordStore';
      //     const data = { keyword: search_value };

      //     fetch(url, {
      //       method: 'POST',
      //       headers: {
      //         'Content-Type': 'application/json',
      //       },
      //       body: JSON.stringify(data),
      //     })
      //       .then(response => response.json())
      //       .then(data => console.log(data))
      //       .catch(error => console.error('Error:', error));
      //   }
      // });
      //end li click
    } else {
      // searchList();
      if (!$(this).hasClass('header_search')) {
        searchList($this);
      } else {
        $('.search_result').html('');
      }
    }

    let searchClicked = false;

    $('.search_result ul li a').on('click', function (event) {
      if (searchClicked) return;
      searchClicked = true;
      event.preventDefault(); // Stop default link behavior

      clearTimeout(searchTimer); // Cancel any pending search timer

      let linkText = $(this).text().trim(); // Get only text
      let linkHref = $(this).attr('href'); // Get the link URL

      sendKeywordToAPI(linkText, true); // Send immediately
      setTimeout(() => {
        window.location.href = linkHref; // Navigate after a short delay
      }, 50);
    });
  });

  // Close dropdown result when click anywhere.
  $(document).on('click', function (e) {
    if (
      !$(e.target).closest('.Form__Select.Select').length &&
      !$(e.target).closest('.search_result').length
    ) {
      $('.search_result').html('');
      $('.search_result').removeClass('tw:border');
    }
  });

  //mobile search click
  $('.Header__Wrapper a.Header__Icon[data-action="toggle-search"]').on('click', function (e) {
    e.preventDefault();
    var attr_hidden = $('#sidebar-menu').attr('aria-hidden');
    if (attr_hidden == 'true') {
      $('button.Header__Icon.hidden-desk').trigger('click');
      setTimeout(function () {
        $('.Drawer__Content .search_product.header_search').focus();
      }, 300); // OPTIMIZED: Reduced from 900ms to 300ms for faster mobile search functionality
    }
    return false;
  });

  //new variant dropdown js
  $(document).on('click', '.ProductForm .dropdown-list .dropdown-inner .select-btn', function (e) {
    e.stopPropagation(); // Important to stop bubbling
    $(this).parent('.dropdown-inner').toggleClass('active');
    // $('body').css('overflow',"hidden");
    $('body').toggleClass('no-scroll');
  });

  //on varianct change in dropdown
  $(document).on(
    'click',
    '.ProductForm .dropdown-list .dropdown-inner .options ul li',
    function () {
      $('body').removeClass('no-scroll');
      if (!$(this).hasClass('disable')) {
        var val = $(this).attr('data-value');
        $(this).siblings('li').removeClass('selected');
        $(this).addClass('selected');

        // $(this).parents('.options-inner').find('.number-of-days input').val(val);
        var val = $(this).attr('data-value');
        $(this)
          .parents('.dropdown-inner')
          .find('.select-btn')
          .html(
            val +
              '<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.8421 12L15.5414 15.8519L11.1579 12L10 13.037L15.5414 18L21 13.037L19.8421 12Z" fill="currentColor"/></path></svg>',
          );
        $(this).parents('.dropdown-inner').removeClass('active');

        $(this)
          .parents('form.ProductForm')
          .find('.ProductForm__Variants ul li input[type="radio"][value="' + val + '"]')
          .next('label')
          .trigger('click');

        var price = $(this).attr('data-price');
        var perdayprice = $(this).attr('data-per-day');

        var qty_val = parseInt(
          $(this).parents('.dropdown-list').find('.QuantitySelector input').val(),
        );

        if (qty_val == 1) {
          if (price) {
            $(this).parents('.dropdown-list').find('.total-price .total-price-text').html(price);
          }
          if (perdayprice) {
            $(this)
              .parents('.dropdown-list')
              .find('.total-price .total-price-day')
              .html(perdayprice);
          }
        } else {
          var price = parseInt($(this).attr('data-qty-price'));
          var days = parseInt(val);
          var curr_symbol = $(this).attr('data-curr-symbol');

          var qty_price = price * qty_val;
          var perdayqty_price = price / days;
          var perday_total = perdayqty_price * qty_val;

          var format_price = Shopify.formatMoney(qty_price, window.theme.moneyFormat);
          $(this)
            .parents('.dropdown-list')
            .find('.total-price .total-price-text')
            .html(curr_symbol + format_price.split('.')[0]);

          if (perdayprice) {
            $(this)
              .parents('.dropdown-list')
              .find('.total-price .total-price-day')
              .html(perdayprice);
          }

          // var perdayformat_price = Shopify.formatMoney(perday_total, window.theme.moneyFormat);
          // $(this).parents('.dropdown-list').find('.total-price .total-price-day').html(perdayformat_price+'/day');
        }
      }
    },
  );

  //on input change
  // $(document).on('input','.ProductForm .dropdown-list .dropdown-inner .options .number-of-days input',function(){
  //   var val = $(this).val();
  //   $(this).parents('.options').find('ul li[data-value="'+val+'"]').trigger('click');
  // });

  // $('.ProductForm .dropdown-list .dropdown-inner .options .number-of-days input').on('click', function(e) {
  //  e.stopPropagation(); // Important to stop bubbling
  //   // $(this).focus();
  //   // $(this).parent('.dropdown-inner').addClass('active');
  // });

  //on apply button click
  // $(document).on('click','.ProductForm .dropdown-list .dropdown-inner .options .number-of-days button.apply-btn',function(event){
  //   event.preventDefault();
  //   event.stopPropagation();
  //   var val = $(this).parents('.options').find('ul li.selected').attr('data-value');
  //   $(this).parents('.dropdown-inner').find('.select-btn').html(val + '<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.8421 12L15.5414 15.8519L11.1579 12L10 13.037L15.5414 18L21 13.037L19.8421 12Z" fill="currentColor"/></path></svg>')
  //   $(this).parents('.dropdown-inner').removeClass('active');
  //   $('body').removeClass('no-scroll');

  //   $(this).parents('form.ProductForm').find('.ProductForm__Variants ul li input[type="radio"][value="'+val+'"]').addClass('hiii')
  //   $(this).parents('form.ProductForm').find('.ProductForm__Variants ul li input[type="radio"][value="'+val+'"]').next('label').trigger('click');

  //   var price = $(this).parents('.options').find('ul li.selected').attr('data-price');
  //   var perdayprice = $(this).parents('.options').find('ul li.selected').attr('data-per-day');

  //   var qty_val = parseInt($(this).parents('.dropdown-list').find('.QuantitySelector input').val());

  //     if(qty_val == 1){
  //       if(price){
  //         $(this).parents('.dropdown-list').find('.total-price .total-price-text').html(price);
  //       }
  //       if(perdayprice){
  //         $(this).parents('.dropdown-list').find('.total-price .total-price-day').html(perdayprice);
  //       }
  //     }else{
  //       var price = parseInt($(this).parents('.options').find('ul li.selected').attr('data-qty-price'));
  //       var days = parseInt(val);
  //       var curr_symbol = $(this).parents('.options').find('ul li.selected').attr('data-curr-symbol')

  //       var qty_price = price * qty_val;
  //       var perdayqty_price = price / days;
  //       var perday_total = perdayqty_price * qty_val;

  //       var format_price = Shopify.formatMoney(qty_price, window.theme.moneyFormat);
  //       $(this).parents('.dropdown-list').find('.total-price .total-price-text').html(curr_symbol + format_price.split(".")[0]);

  //       if(perdayprice){
  //         $(this).parents('.dropdown-list').find('.total-price .total-price-day').html(perdayprice);
  //       }

  //       // var perdayformat_price = Shopify.formatMoney(perday_total, window.theme.moneyFormat);
  //       // $(this).parents('.dropdown-list').find('.total-price .total-price-day').html(perdayformat_price+'/day');
  //     }
  // });

  //close btn
  $(document).on(
    'click',
    '.ProductForm .dropdown-list .dropdown-inner .options .close-btn-mob .mob-btn',
    function (event) {
      $(this).parents('.dropdown-inner').removeClass('active');
      $('body').removeClass('no-scroll');
    },
  );

  //on qty button click
  $(document).on(
    'click',
    '.ProductForm .dropdown-list .cus-QuantitySelector .QuantitySelector button',
    function (event) {
      var qty_val = parseInt($(this).siblings('input').val());
      var var_price = parseInt(
        $('.ProductForm .dropdown-list .ProductForm_dropdown .options ul li.selected').attr(
          'data-qty-price',
        ),
      );
      var var_days = parseInt(
        $('.ProductForm .dropdown-list .ProductForm_dropdown .options ul li.selected').attr(
          'data-value',
        ),
      );
      var var_curr_symbol = $(
        '.ProductForm .dropdown-list .ProductForm_dropdown .options ul li.selected',
      ).attr('data-curr-symbol');

      var qty_price = var_price * qty_val;
      var perdayqty_price = var_price / var_days;
      var perday_total = perdayqty_price * qty_val;

      var format_price = Shopify.formatMoney(qty_price, window.theme.moneyFormat);
      $(this)
        .parents('.dropdown-list')
        .find('.total-price .total-price-text')
        .html(var_curr_symbol + format_price.split('.')[0]);

      // var perdayformat_price = Shopify.formatMoney(perday_total, window.theme.moneyFormat);
      // $(this).parents('.dropdown-list').find('.total-price .total-price-day').html(perdayformat_price+'/day');
    },
  );

  //on qty change
  $(document).on(
    'input',
    '.ProductForm .dropdown-list .cus-QuantitySelector .QuantitySelector input',
    function (event) {
      var qty_val = parseInt($(this).val());
      var var_price = parseInt(
        $('.ProductForm .dropdown-list .ProductForm_dropdown .options ul li.selected').attr(
          'data-qty-price',
        ),
      );
      var var_days = parseInt(
        $('.ProductForm .dropdown-list .ProductForm_dropdown .options ul li.selected').attr(
          'data-value',
        ),
      );
      var var_curr_symbol = $(
        '.ProductForm .dropdown-list .ProductForm_dropdown .options ul li.selected',
      ).attr('data-curr-symbol');

      var qty_price = var_price * qty_val;
      var perdayqty_price = var_price / var_days;
      var perday_total = perdayqty_price * qty_val;

      var format_price = Shopify.formatMoney(qty_price, window.theme.moneyFormat);
      $(this)
        .parents('.dropdown-list')
        .find('.total-price .total-price-text')
        .html(var_curr_symbol + format_price.split('.')[0]);

      // var perdayformat_price = Shopify.formatMoney(perday_total, window.theme.moneyFormat);
      // $(this).parents('.dropdown-list').find('.total-price .total-price-day').html(perdayformat_price+'/day');
    },
  );
});
